const TemplatesActionTypes = {
  START_FETCH_EMAIL_USER_TEMPLATES: 'START_FETCH_EMAIL_USER_TEMPLATES',
  START_FETCH_EMAIL_SYSTEM_TEMPLATES: 'START_FETCH_EMAIL_SYSTEM_TEMPLATES',

  START_FETCH_DOCUMENT_USER_TEMPLATES: 'START_FETCH_DOCUMENT_USER_TEMPLATES',
  START_FETCH_DOCUMENT_SYSTEM_TEMPLATES: 'START_FETCH_DOCUMENT_SYSTEM_TEMPLATES',

  START_FETCH_SMS_USER_TEMPLATES: 'START_FETCH_SMS_USER_TEMPLATES',
  START_FETCH_SMS_SYSTEM_TEMPLATES: 'START_FETCH_SMS_SYSTEM_TEMPLATES',

  FETCH_TEMPLATES_SUCCESS: 'FETCH_TEMPLATES_SUCCESS',
  FETCH_TEMPLATES_FAILURE: 'FETCH_TEMPLATES_FAILURE',

  START_DELETE_TEMPLATES: 'START_DELETE_TEMPLATES',
  DELETE_TEMPLATES_SUCCESS: 'DELETE_TEMPLATES_SUCCESS',
  DELETE_TEMPLATES_FAILURE: 'DELETE_TEMPLATES_FAILURE',

  FETCH_SINGLE_TEMPLATE: 'FETCH_SINGLE_TEMPLATE',
  FETCH_SINGLE_TEMPLATE_SUCCESS: 'FETCH_SINGLE_TEMPLATE_SUCCESS',
  FETCH_SINGLE_TEMPLATE_FAILURE: 'FETCH_SINGLE_TEMPLATE_FAILURE',

  UPDATE_EMAIL_TEMPLATE_START: 'UPDATE_EMAIL_TEMPLATE_START',
  UPDATE_DOCUMENT_TEMPLATE_START: 'UPDATE_DOCUMENT_TEMPLATE_START',
  UPDATE_SMS_TEMPLATE_START: 'UPDATE_SMS_TEMPLATE_START',
};

export default TemplatesActionTypes;
